import type { PaymentMethod } from '../types';
import { usePaymentMethodSelectContext } from './PaymentMethodSelectContext';
import { usePaymentMethodSubmit, type SubmitResult } from './submitPaymentMethod';
import { useIsPaymentMethodValid } from './validatePaymentMethod';

type PaymentMethodSelectContext = {
    selectedPaymentMethod: PaymentMethod | null;
    isBusy: boolean;
    isValid: boolean;
    submit: () => Promise<SubmitResult>;
};

export function usePaymentMethodSelect(): PaymentMethodSelectContext {
    const { selectedPaymentMethod, isBusy } = usePaymentMethodSelectContext();

    const submit = usePaymentMethodSubmit();
    const isValid = useIsPaymentMethodValid();

    return {
        selectedPaymentMethod,
        isBusy,
        isValid,
        submit,
    };
}
